import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import TebligatDropdown from '../../components/TebligatDropdown';
import Dropdown from '../../components/Dropdown';
import { BASVURU_HARCI, VEKALET_SURET_HARCI, VEKALET_PULU } from '../../constants/constants';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>İcra Takibi Nedir?</h5>",
        answer: ["İcra takibi, borçlunun borcunu herhangi bir sebeple ödememesi durumunda alacaklının bu borcu icra yoluyla tahsil etmek üzere icra müdürlüğü nezdinde başlattığı takip işlemidir. Temelde iki tür icra yolu vardır. Bunlar; ilamlı ve ilamsız takiplerdir."],
    },
    {
        question: "<h5>İlamsız İcra Takibi:</h5>",
        answer: ["Bir mahkeme kararı olmaksızın para veya teminat alacaklarının tahsili için başlatılır.", "Kiralanan bir taşınmazın tahliyesi de ilamsız takip yolu ile istenebilir."],
    },
    {
        question: "<h5>İlamlı İcra Takibi:</h5>",
        answer: ["Bir mahkeme kararına dayanarak başlatılan takip türüdür."],
    },
    {
        question: "<h5>İcra Masrafı Hesaplama:</h5>",
        answer: ["Takibi başlatırken, belirli harç ve masrafların peşin olarak ödenmesi gerekir.", "Bu ödemeler icra dosyası borcuna eklenir ve başlangıçta alacaklı tarafından karşılanır.", "Gerekli harç ve masraflar, takibin ilamlı veya ilamsız olmasına göre farklılık gösterir."],
    },
    {
        question: "<h5>İlamsız Takiplerde Masraflar:</h5>",
        answer: ["Başvuru harcı", "Peşin harç", "Vekâlet suret harcı", "Baro (vekâlet) pulu", "Tebligat ve dosya gideri"],
    },
    {
        question: "<h5>İlamlı Takiplerde Masraflar:</h5>",
        answer: ["Peşin harç hariç, ilamsız takiplerde istenen tüm harç ve masraflar geçerlidir."],
    },
    {
        question: "<h5>Peşin Harç Hesaplama:</h5>",
        answer: ["Alacak tutarının %0,5'i (binde 5) oranında hesaplanır ve takip başlangıcında alacaklıdan tahsil edilir."],
    },
    {
        question: "<h5>Ek Hususlar:</h5>",
        answer: ["Alacaklı, icra takibini bizzat başlatacaksa baro pulu ve vekalet suret harcı gerekmez.", "Bu durumda alacaklı, peşin harç, tebligat ve dosya giderinden sorumlu olacaktır."],
    },
];

const ilamOptions = [{text: "İlamsız", value: 1}, {text: "İlamlı", value: 2}];

const IcraMasrafiHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [borcluSayisi, setBorcluSayisi] = useState(null);
	const [alacakTutari, setAlacakTutari] = useState(null);
	const [tebligatValue, setTebligatValue] = useState(null);
	const [ilamValue, setIlamValue] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setAlacakTutari(Number(decodeURIComponent(atob(query.get('alacakTutari')))));
            setBorcluSayisi(Number(decodeURIComponent(atob(query.get('borcluSayisi')))));
            setIlamValue(Number(decodeURIComponent(atob(query.get('ilamValue')))));
            setTebligatValue(Number(decodeURIComponent(atob(query.get('tebligatValue')))));
			setCalculated(true);
		}
		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (tebligatValue && borcluSayisi && ilamValue !== null) {
            let newResults = [];

            if(ilamValue === 1) {
                if (alacakTutari) {
                    newResults = [
                        { text: "Başvuru Harcı", value: BASVURU_HARCI },
                        { text: "Vekalet Suret Harcı", value: VEKALET_SURET_HARCI },
                        { text: "Vekalet Pulu", value: VEKALET_PULU },
                        { text: "Tebligat Gideri", value: tebligatValue * borcluSayisi },
                        { text: "Alacak Miktarı Masrafı", value: alacakTutari / 200 },
                        { text: "Toplam İcra Masrafı", value: alacakTutari / 200 + BASVURU_HARCI + VEKALET_SURET_HARCI + VEKALET_PULU + tebligatValue * borcluSayisi },
                    ];
                } else {
                    alert("Lütfen alacak tutarını giriniz.");
                    return;
                }
            } else {
                newResults = [
                    { text: "Başvuru Harcı", value: BASVURU_HARCI },
                    { text: "Vekalet Suret Harcı", value: VEKALET_SURET_HARCI },
                    { text: "Vekalet Pulu", value: VEKALET_PULU },
                    { text: "Tebligat Gideri", value: tebligatValue * borcluSayisi },
                    { text: "Toplam İcra Masrafı", value: BASVURU_HARCI + VEKALET_SURET_HARCI + VEKALET_PULU + tebligatValue * borcluSayisi },
                ];
            }

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				tebligatValue: btoa(encodeURIComponent(tebligatValue.toString())),
                ilamValue: btoa(encodeURIComponent(ilamValue)),
				borcluSayisi: btoa(encodeURIComponent(borcluSayisi.toString())),
				alacakTutari: btoa(encodeURIComponent(alacakTutari?.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>İcra Masrafı Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="İcra masrafı hesaplama, borçludan tahsil edilecek borçla ilgili yasal süreçte oluşan harç, dosya masrafları, vekalet ücretleri ve diğer giderlerin toplamını içerir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>İcra Masrafı Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">İcra Masrafı Hesapla</h1>
                    <p>İcra masrafı hesaplama, borçludan tahsil edilecek borçla ilgili yasal süreçte oluşan harç, dosya masrafları, vekalet ücretleri ve diğer giderlerin toplamını içerir.</p>
                    
                    <TebligatDropdown value={tebligatValue} setValue={setTebligatValue} />
                    <Dropdown selectedOption={ilamValue} options={ilamOptions} label="Hesaplama Türünü Seçiniz" setSelectedOption={setIlamValue} />
                    <InputField value={borcluSayisi} setValue={setBorcluSayisi} trailText="kişi" label="Borçlu Sayısı" type="number" />

                    {ilamValue === 1 && <InputField value={alacakTutari} setValue={setAlacakTutari} label="Alacak Tutarı" trailText="TL" type="number"></InputField>}
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="İcra Takibi Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IcraMasrafiHesaplama);
